import React from "react";
import { makeStyles } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles(() => ({
  root: {
    marginTop: 60,
  },
  content: {
    backgroundColor: ({ type }) => {
      switch(type) {
        case "success":
          return "#4bb543";

        case "warning":
          return "#FFCC00";

        case "error":
          return "#f44336";
        
        default:
          return "#808285";
      }
    }
  },
}));

const SnackBar = ({ type, message, handleClose }) => {
  const classes = useStyles({ type });

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      autoHideDuration={6000}
      onClose={handleClose}
      className={classes.root}
      open={message ? true : false}
    >
      <SnackbarContent
        aria-describedby="message-id2"
        className={classes.content}
        action={
          <>
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
        message={
          <span id="message-id2">
            <div>{message}</div>
          </span>
        }
      />
    </Snackbar>
  );
};

export default SnackBar;
